import { FC } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import { CarouselProvider } from 'src/common/providers/CarouselProvider';
import Carousel from 'src/common/components/dockyard/Carousel';
import CarouselButtons from 'src/common/components/dockyard/CarouselButtons';
import ListingCardMinimal from 'src/homepage/components/ListingCardMinimal';
import type { HomepageResults } from 'src/common/types/api/v4/search/v1/homepage';
import styles from './HomepageExperiences.module.scss';

type HomepageExperiencesProps = {
  experienceListings: HomepageResults['experience_listings'];
};

const HomepageExperiences: FC<HomepageExperiencesProps> = ({
  experienceListings,
}) => {
  const [t] = useTranslation('home-page');

  return (
    <PitchPageLayout
      backgroundColor="midnight01"
    >
      <div className={styles.root}>
        <div className={styles.header}>
          <div className={styles.title}>
            <Typography
              type="h3"
              size="display-5"
              sizeFromBreakpointM="display-4"
            >
              <Trans
                t={t}
                i18nKey="experiences--title"
                components={{ br: <br className={styles.mobileOnly} /> }}
              />
            </Typography>
          </div>
          <div className={styles.subTitle}>
            <Typography type="p" size="body-xl">
              <Trans
                t={t}
                i18nKey="experiences--subtitle"
                components={{ br: <br className={styles.mobileOnly} /> }}
              />
            </Typography>
          </div>
        </div>
        <CarouselProvider>
          <Carousel>
            {experienceListings?.map((listing) => (
              <ListingCardMinimal
                key={listing?.listing_url}
                reviewAverage={listing?.review_average ?? undefined}
                primaryCategory={listing?.primary_category}
                breadcrumbs={listing?.breadcrumbs}
                headline={listing?.headline}
                href={listing?.listing_url ?? ''}
                imgSrc={listing?.photo_url}
                imgOptimizationWidth={500}
              />
            ))}
          </Carousel>
          <CarouselButtons
            spacing="together"
            variant="primary-blue"
          />
        </CarouselProvider>
      </div>
    </PitchPageLayout>
  );
};

export default HomepageExperiences;
